// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "recorder" + "." + "adc348889829553ea207" + ".bundle.js";
};